export const createUserSlice = (set) => ({
    users: {
        loading: false,
        saleLoading: false,
        data: [],
        single: {},
        sales: [],
        boughts: [],
        userAgentWage: [],
        selectedItem: null,
        businesses: [],
        filtered: [],
        filteredItem: "",
        filterUsers: [],
        promoters: [],
        totalUsers: 1
    },
    USER_LOADING: (loading) => set(state => ({ users: { ...state.users, loading } })),
    SALE_LOADING: (saleLoading) => set(state => ({ users: { ...state.users, saleLoading } })),
    GET_SINGLE_USER: (user) => set(state => ({ users: { ...state.users, single: user } })),
    GET_USER_BUSINESSES: (businesses) => set(state => ({ users: { ...state.users, businesses, loading: false } })),
    GET_ALL_USERS: (users) => set(state => ({ users: { ...state.users, data: users, filtered: users, loading: false } })),
    GET_FILTER_USERS: (filterUsers) => set(state => ({ users: { ...state.users, filterUsers, loading: false } })),
    GET_PROMOTERS: (promoters) => set(state => ({ users: { ...state.users, promoters, loading: false } })),
    GET_USER_SALE: (sales) => set(state => ({ users: { ...state.users, sales, loading: false } })),
    GET_USER_AGENT_WAGE: (userAgentWage) => set(state => ({ users: { ...state.users, userAgentWage } })),
    FILTERED_ITEM: (filteredItem) => set(state => ({ users: { ...state.users, filteredItem } })),
    FILTER_USERS: (filtered) => set(state => ({ users: { ...state.users, filtered } })),
    SET_TOTAL_USERS: (totalUsers) => set(state => ({ users: { ...state.users, totalUsers } }))

});
